import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Button,
  FormControl,
  TextField,
  IconButton,
  Select,
  MenuItem,
  Autocomplete,
  Checkbox,
  Paper,
  Popper,
  Skeleton,
  FormHelperText,
  InputLabel,
  Stack,
  Chip,
  Divider,
} from "@mui/material";
import {
  headingStyle,
  labPageButton,
  tableCellLab,
  tableRowLab,
  xBtn,
} from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import {
  menuItemStyle,
  primaryBtn,
  selectField,
  textfieldText,
  textfieldTextBlueBorderPharmacy,
} from "../../style/AppointmentStyle";
import { drTableRow } from "../../style/DrApotComponentStyle";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import {
  addBtn,
  borderInset,
  pharmacyPageBlueBtn,
  selectFieldTextBlueBr,
} from "../../style/PharmacyStyle";
import PrePatientPharmacyMedicine from "../../helper/PrePatientPharmacyMedicine";
import { useDispatch, useSelector } from "react-redux";
import useDebounce from "../../hooks/UseDebounce";
import UseGetInvoice from "../../helper/UseGetInvoice";
import UseGetMedicineList from "../../helper/UseGetMedicineList";
import UseMedicineByName from "../../helper/UseMedicineByName";
import UseGetMedicineDetail from "../../helper/UseGetMedicineDetail";
import {
  getMedicineByName,
  getPriceByQuantity,
  getPriceByQuantityForReturn,
  getPharmacyDetails,
} from "../../connections/getApi";
import { useQuery } from "@tanstack/react-query";
import { useReactToPrint } from "react-to-print";
import { generateBill, pharmacyCreateBill } from "../../connections/postApi";
import { showToast } from "../../utils/toastUtil";
import { Link } from "react-router-dom";
import UseGetAllMedicineList from "../../helper/UseGetAllMedicineList";
import UseFetchGetOrganizationDetails from "../../helper/UseFetchGetOrganizationDetails";
import PharmacyInvoice from "../PrintCompoents/PharmacyInvoice";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { drTableGreen, drTableRowBlueBg } from "../../style/PatinetFormStyle";
import {
  orangeButton,
  primaryBtnTeal,
  textfieldTextPrep,
} from "../../style/PatientDetailsStyle";
import Brightness1OutlinedIcon from "@mui/icons-material/Brightness1Outlined";
import {
  expiryMedicineFormate,
  isExpiredDate,
  roundToNearestUnit,
} from "../../utils/constantFunctions";
import CustomModal from "../CustomModal/CustomModal";
import EditMedicineBatchShort from "./EditMedicineBatchShort";
import { Edit } from "@mui/icons-material";

const PrePatientBillPharmacy = ({ onClose, id, refetch }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredMedicines, setFilteredMedicines] = useState([]);
  const [openMedicineList, setOpenMedicines] = useState(false);
  const [select, setSelect] = useState(0);
  const [total, setTotal] = useState(0);
  const [formState, setFormState] = useState({
    name: "",
    uid: "",
    mobile: "",
    age: "",
    gender: "",
    patient_id: "",
    prescription_id: "",
  });
  const [medicines, setMedicines] = useState([
    {
      id: "",
      name: "",
      salt: [],
      quantity: "",
      batchId: null,
      batch: "",
      batchArray: [],
      returned: false,
      stock: "",
      packing: "",
      unitMrp: null,
      mrp: null,
      discount: null,
      gst: null,
      amount: null,
    },
  ]);
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [showButton, setShowButton] = useState(true);
  const [printInvoiceData, setPrintInvoiceData] = useState({});
  const [highlightedIndexMedicine, setHighlightedIndexMedicine] = useState(0);
  const [isButtonDisable, setIsButtonDisable] = useState(false);
  const [isPriceFetching, setIsPriceFetching] = useState(false);
  const priceRequestControllers = useRef(new Map());
  const pendingPriceCount = useRef(0);
  const selectMedicineIdRef = useRef(null);
  const [billSummary, setBillSummary] = useState({
    taxableTotal: 0,
    totalGst: 0,
    discount: 0,
    netPayable: 0,
  });

  // const dispatch = useDispatch();

  useEffect(() => {
    setMedicines([{
      id: "", name: "", salt: [], quantity: "", batchId: null,
      batch: "", batchArray: [], returned: false, stock: "",
      packing: "", unitMrp: null, mrp: null, discount: null, gst: null, amount: null,
    }]);
    setFormState({ name: "", uid: "", mobile: "", age: "", gender: "", patient_id: "", prescription_id: "" });
    setSelectedMedicine(null);
    setSelect(0);
    selectMedicineIdRef.current = null;
    setFilteredMedicines([]);
    setSearchTerm("");
    setErrors({});
    setIsButtonDisable(false);
    setPaymentMode(null);
    setInvoicePaymentsAttributes([{ amount: "", payment_mode: "Cash" }]);
  }, [id]);

  const { data: patient, isLoading } = PrePatientPharmacyMedicine(id);
  const { data: medicineList } = UseGetAllMedicineList();

  const { data: pharmacyDetails } = useQuery({
    queryKey: ["getPharmacyDetails"],
    queryFn: getPharmacyDetails,
    refetchOnWindowFocus: false,
  });
  const roundOff = pharmacyDetails?.payload?.round_off ?? null;

  const { data: orgData } = UseFetchGetOrganizationDetails();
  const orgFeatures =
    orgData?.payload?.organization_features ||
    orgData?.organization_features ||
    [];
  const allowBatchStockZero = orgFeatures.find(
    (f) => f?.key === "allow_batch_stock_zero" && f?.active === true,
  );

  useEffect(() => {
    // Simulating fetching all data on component mount and storing it in local storage or state.
    if (
      medicineList?.payload?.medicines &&
      medicineList?.payload?.medicines?.length > 0
    ) {
      localStorage.setItem(
        "allMedicines",
        JSON.stringify(medicineList?.payload?.medicines),
      );
    }
  }, [medicineList]);

  // const { data: medicineName } = UseMedicineByName(
  //   selectedMedicine?.name,
  //   selectedMedicine?.name
  // );

  const handleSearch = (event) => {
    // console.log(event.target.value);
    const query = event.target.value.toLowerCase();
    setSearchTerm(query);

    const storedMedicines =
      JSON.parse(localStorage.getItem("allMedicines")) || [];

    // Filter medicines based on search query
    const filteredMedicineList = storedMedicines.filter((medicine) =>
      medicine[1].toLowerCase().startsWith(query),
    );

    // Limit the results to top 10 and sort
    let limitedResults = filteredMedicineList.slice(0, 10);
    if (!query) {
      limitedResults = [];
      console.log(limitedResults);
      setHighlightedIndexMedicine(0);
    }
    setFilteredMedicines(limitedResults);
  };

  const { data: medicineDetail } = UseGetMedicineDetail(selectedMedicine?.id);

  useEffect(() => {
    if (patient) {
      setFormState({
        name: patient?.patient?.name,
        uid: patient?.patient?.uid,
        mobile: patient?.patient?.mobile,
        age: patient?.patient?.age,
        gender: patient?.patient?.gender,
        patient_id: patient?.id,
        prescription_id: "",
      });

      setMedicines(
        patient?.medicines?.map((medicine) => ({
          id: medicine?.id,
          name: medicine?.name || "",
          quantity: medicine?.quantity || "",
          batchId: medicine?.batch || null,
          salt: medicine?.salt_related_medicines,
          batch: medicine?.batch || "",
          batchArray: [],
          returned: false,
          stock: medicine?.stock_left,
          packing: medicine?.packing || "",
          unitMrp: medicine?.unit_mrp || null,
          mrp: medicine?.mrp || null,
          discount: `${medicine?.discount || 0}%`,
          gst: (medicine?.cgst || 0) + (medicine?.sgst || 0),
          amount: medicine?.amount || null,
        })),
      );
    }
  }, [patient]);

  const handleAddRow = () => {
    setMedicines([
      ...medicines,
      {
        id: "",
        name: "",
        salt: [],
        quantity: "",
        batchId: null,
        batch: "",
        batchArray: [],
        returned: false,
        stock: "",
        packing: "",
        unitMrp: null,
        mrp: null,
        discount: null,
        gst: null,
        amount: null,
      },
    ]);
  };

  // handle key down with  enter  logic
  const handleChange = (index, field, value) => {
    const newMedicines = medicines.map((medicine, idx) =>
      idx === index ? { ...medicine, [field]: value } : medicine,
    );
    setMedicines(newMedicines);
  };

  // const updateNameAndId = (index, value) => {
  //   const newMedicines = [...medicines];
  //   newMedicines[index] = {
  //     ...newMedicines[index],
  //     id: value[0],
  //     name: value[1],
  //   };
  //   setMedicines(newMedicines);
  // };
  const [paymentMode, setPaymentMode] = useState(null);

  const updateNameAndId = (index, value) => {
    setMedicines((prevMedicines) =>
      prevMedicines.map((medicine, idx) =>
        idx === index
          ? {
              ...medicine,
              id: value[0],
              name: value[1],
              quantity: "",
              batchId: null,
              batch: "",
              batchArray: [],
              returned: false,
              stock: "",
              packing: "",
              unitMrp: null,
              mrp: null,
              discount: null,
              gst: null,
              amount: null,
            }
          : medicine,
      ),
    );
  };
  // const [paymentSplitEnabled, setPaymentSplitEnabled] = useState(false);
  const [invoicePaymentsAttributes, setInvoicePaymentsAttributes] = useState([
    { amount: "", payment_mode: "Cash" }, // default row
  ]);
  const paymentModes = [
    { label: "UPI", value: "UPI" },
    { label: "Cash", value: "Cash" },
    { label: "Card", value: "Card" },
    { label: "Cheque", value: "Cheque" },
  ];
  const getAvailablePaymentModes = (currentIndex) => {
    const selectedModes = invoicePaymentsAttributes
      .map((item, index) => (index !== currentIndex ? item.payment_mode : null))
      .filter(Boolean);

    return paymentModes.filter((mode) => !selectedModes.includes(mode.value));
  };

  const [specialDiscountPct, setSpecialDiscountPct] = useState("");
  const [specialDiscountINR, setSpecialDiscountINR] = useState("");
  const specialDiscountPctRef = useRef("");

  const getRawTotal = () =>
    medicines.reduce((sum, m) => {
      if (m.name && m.quantity > 0 && m.id)
        return sum + (parseFloat(m.unitMrp) || 0) * (parseFloat(m.quantity) || 0);
      return sum;
    }, 0);

  const handleSpecialDiscountPct = (val) => {
    setSpecialDiscountPct(val);
    const pct = parseFloat(val);
    if (!val || isNaN(pct)) { setSpecialDiscountINR(""); return; }
    setSpecialDiscountINR((getRawTotal() * pct / 100).toFixed(2));
  };

  const handleSpecialDiscountINR = (val) => {
    setSpecialDiscountINR(val);
    const inr = parseFloat(val);
    const raw = getRawTotal();
    if (!val || isNaN(inr) || raw === 0) { setSpecialDiscountPct(""); return; }
    setSpecialDiscountPct(((inr / raw) * 100).toFixed(2));
  };

  const [errors, setErrors] = useState({});

  // console.log(medicines);

  // const handleKeyDown = (e, index, field) => {
  //   if (e.key === "Enter" && field === "name") {
  //     e.preventDefault();

  //     // If no salts are available, move focus to quantity
  //     if (medicines[index].salt?.length === 0) {
  //       if (!medicines[index]?.name) {
  //         setTimeout(() => document.getElementById(`submit`).focus(), 0);
  //         return;
  //       }

  //       const currentInput = medicines[index]?.name?.toLowerCase() || "";
  //       console.log(currentInput, 'currentInput')
  //       const topOption = filteredMedicines.find((medicine) =>
  //         (medicine[1] || "").toLowerCase().startsWith(currentInput)
  //       );

  //       if (topOption) {
  //         setTimeout(() => {
  //           updateNameAndId(index, topOption);
  //           handlePresence(index, topOption);
  //           setSelectedMedicine({ name: topOption[1], id: topOption[0] });
  //           document.getElementById(`quantity-${index}`).focus();
  //         }, 100);
  //       }
  //     }

  //     // If salts are available, move focus to salt table
  //     if (medicines[index].salt?.length > 0) {
  //       e.preventDefault();

  //       if (!medicines[index]?.name) {
  //         setTimeout(() => document.getElementById(`submit`).focus(), 0);
  //         return;
  //       }

  //       let saltIndex = 0;
  //       const saltCount = medicines[index].salt.length;

  //       // Function to focus on the next salt or move to quantity
  //       const selectNextSalt = () => {
  //         if (saltIndex < saltCount) {
  //           const saltId = `selectSalt-${index}-${saltIndex}`;
  //           const saltElement = document.getElementById(saltId);
  //           if (saltElement) {
  //             // console.log(saltElement);

  //             setTimeout(() => {
  //               saltElement.focus();
  //               saltIndex++;

  //               // just to preserve medi name
  //               // Preserve medicine name in state
  //               const newMedicines = medicines.map((medicine, idx) =>
  //                 idx === index ? { ...medicine, name: medicines[index]?.name } : medicine
  //               );
  //               setMedicines(newMedicines);

  //               saltElement.addEventListener("keydown", (ev) => {
  //                 if (ev.key === "Enter") {
  //                   ev.preventDefault();
  //                   selectNextSalt(); // Move to next salt or quantity
  //                 }
  //               });
  //             }, 100); // Slight delay to ensure rendering
  //           }
  //         } else {
  //           // Move focus to quantity field after last salt
  //           setTimeout(
  //             () => document.getElementById(`quantity-${index}`).focus(),
  //             0
  //           );
  //         }
  //       };

  //       // Start focusing on the first salt
  //       selectNextSalt();
  //     }
  //   }

  //   // Handle navigation to the quantity field
  //   if (e.key === "Enter" && field === "quantity") {
  //     setTimeout(() => document.getElementById(`return-${index}`).focus(), 0);
  //   }

  //   // Handle adding a new row and focusing on the next medicine name
  //   if (e.key === "Enter" && field === "return") {
  //     if (medicines?.length > index + 1) {
  //       setTimeout(() => document.getElementById(`name-${index + 1}`).focus(), 0);
  //     } else {
  //       handleAddRow();
  //       setTimeout(() => document.getElementById(`name-${index + 1}`).focus(), 0);
  //     }
  //   }
  // };

  const handleKeyDown = (e, index, field) => {
    if (field === "name") {
      if (["ArrowDown", "ArrowUp"].includes(e.key)) {
        e.preventDefault();
        // Navigate options with arrow keys
        setHighlightedIndexMedicine((prevIndex) => {
          if (e.key === "ArrowDown") {
            return prevIndex < filteredMedicines?.length - 1
              ? prevIndex + 1
              : 0;
          } else {
            return prevIndex > 0
              ? prevIndex - 1
              : filteredMedicines?.length - 1;
          }
        });
      } else if (e.key === "Enter") {
        // If no salts are available, move focus to quantity
        if (!medicines[index].salt?.length) {
          if (!medicines[index]?.name) {
            setTimeout(() => document.getElementById(`submit`).focus(), 0);
            return;
          }

          // if (medicines[index]?.id) {
          //   setTimeout(
          //     () => document.getElementById(`quantity-${index}`).focus(),
          //     0
          //   );h
          //   return;
          // }

          e.preventDefault();
          e.stopPropagation();
          const topOption = filteredMedicines[highlightedIndexMedicine];
          console.log(topOption, "topOption");

          if (topOption) {
            console.log(topOption, "topOption inside if");

            setTimeout(() => {
              // setHighlightedIndexMedicine(0);
              updateNameAndId(index, topOption);
              handlePresence(index, topOption);
              setTimeout(() => {
                setHighlightedIndexMedicine(0);
                document.getElementById(`quantity-${index}`).focus();
              }, 0);
            }, 100);
          } else {
            setHighlightedIndexMedicine(0);
            setTimeout(
              () => document.getElementById(`quantity-${index}`).focus(),
              0,
            );
          }
        }
        // If salts are available, move focus to salt table
        if (medicines[index].salt?.length > 0) {
          e.preventDefault();

          if (!medicines[index]?.name) {
            setTimeout(() => document.getElementById(`submit`).focus(), 0);
            return;
          }

          let saltIndex = 0;
          const saltCount = medicines[index].salt.length;

          // Function to focus on the next salt or move to quantity
          const selectNextSalt = () => {
            if (saltIndex < saltCount) {
              const saltId = `selectSalt-${index}-${saltIndex}`;
              const saltElement = document.getElementById(saltId);
              if (saltElement) {
                // console.log(saltElement);
                setTimeout(() => {
                  saltElement.focus();
                  saltIndex++;

                  // just to preserve medi name
                  // Preserve medicine name in state
                  const newMedicines = medicines.map((medicine, idx) =>
                    idx === index
                      ? { ...medicine, name: medicines[index]?.name }
                      : medicine,
                  );
                  setMedicines(newMedicines);

                  saltElement.addEventListener("keydown", (ev) => {
                    if (ev.key === "Enter") {
                      ev.preventDefault();
                      selectNextSalt(); // Move to next salt or quantity
                    }
                  });
                }, 100); // Slight delay to ensure rendering
              }
            } else {
              // Move focus to quantity field after last salt
              setTimeout(
                () => document.getElementById(`quantity-${index}`).focus(),
                0,
              );
            }
          };

          // Start focusing on the first salt
          selectNextSalt();
        }
      } else if (e.key === "Tab") {
        // If no salts are available, move focus to quantity
        if (medicines[index].salt?.length === 0) {
          if (!medicines[index]?.name) {
            setTimeout(() => document.getElementById(`submit`).focus(), 0);
            return;
          }

          e.preventDefault();
          const topOption = filteredMedicines[highlightedIndexMedicine];
          console.log(topOption, "topOption");
          if (topOption) {
            updateNameAndId(index, topOption);
            handlePresence(index, topOption);
            setHighlightedIndexMedicine(0);
            setTimeout(() => {
              document.getElementById(`quantity-${index}`).focus();
            }, 100);
          } else {
            setHighlightedIndexMedicine(0);
            setTimeout(
              () => document.getElementById(`quantity-${index}`).focus(),
              0,
            );
          }
        }
        // If salts are available, move focus to salt table
        if (medicines[index].salt?.length > 0) {
          e.preventDefault();

          if (!medicines[index]?.name) {
            setTimeout(() => document.getElementById(`submit`).focus(), 0);
            return;
          }

          let saltIndex = 0;
          const saltCount = medicines[index].salt.length;

          // Function to focus on the next salt or move to quantity
          const selectNextSalt = () => {
            if (saltIndex < saltCount) {
              const saltId = `selectSalt-${index}-${saltIndex}`;
              const saltElement = document.getElementById(saltId);
              if (saltElement) {
                // console.log(saltElement);
                setTimeout(() => {
                  saltElement.focus();
                  saltIndex++;

                  // just to preserve medi name
                  // Preserve medicine name in state
                  const newMedicines = medicines.map((medicine, idx) =>
                    idx === index
                      ? { ...medicine, name: medicines[index]?.name }
                      : medicine,
                  );
                  setMedicines(newMedicines);

                  saltElement.addEventListener("keydown", (ev) => {
                    if (ev.key === "Enter") {
                      ev.preventDefault();
                      selectNextSalt(); // Move to next salt or quantity
                    }
                  });
                }, 100); // Slight delay to ensure rendering
              }
            } else {
              // Move focus to quantity field after last salt
              setTimeout(
                () => document.getElementById(`quantity-${index}`).focus(),
                0,
              );
            }
          };

          // Start focusing on the first salt
          selectNextSalt();
        }
      }
    }

    // Handle navigation to the quantity field
    if (e.key === "Enter" && field === "quantity") {
      setTimeout(() => document.getElementById(`return-${index}`).focus(), 0);
      // if (medicines?.length > index + 1) {
      //   setTimeout(() => document.getElementById(`name-${index + 1}`).focus(), 0);
      // } else {
      //   handleAddRow();
      //   setTimeout(() => document.getElementById(`name-${index + 1}`).focus(), 0);
      // }
    }

    // Handle adding a new row and focusing on the next medicine name
    if (e.key === "Enter" && field === "return") {
      if (medicines?.length > index + 1) {
        setTimeout(
          () => document.getElementById(`name-${index + 1}`).focus(),
          0,
        );
      } else {
        handleAddRow();
        setTimeout(
          () => document.getElementById(`name-${index + 1}`).focus(),
          0,
        );
      }
    }
  };

  const handlePresence = async (index, value) => {
    const medicineNames = medicines
      ?.slice(0, medicines?.length > 1 ? medicines?.length - 1 : 0)
      .map((med) => med.name)
      .join(",");
    // encodeURIComponent(medicineNames)
    // console.log(medicineNames);
    try {
      const res = await getMedicineByName(
        encodeURIComponent(medicineNames),
        encodeURIComponent(value[1]),
      );

      //  console.log(res.payload?.presence);
      if (res?.payload?.presence) {
        const updatedMedicines = medicines.map((medicine, i) =>
          i === index
            ? { ...medicine, id: "", name: "", description: "", remark: "" }
            : medicine,
        );

        // Update the state with the cleared fields
        setMedicines(updatedMedicines);

        console.log(updatedMedicines, "Updated medicines list");
        showToast("Medicine already present in the list", "ERROR");
      }
    } catch (error) {
      console.log(error);
    }
    // console.log(value, " call api to check ");
    setFilteredMedicines([]);
  };

  const handleMedicineChange = (index, field, value) => {
    const newMedicines = medicines.map((medicine, idx) =>
      idx === index ? { ...medicine, [field]: value } : medicine,
    );
    setMedicines(newMedicines);
  };

  //packing and stock show after select medicine
  useEffect(() => {
    if (medicineDetail && select !== null && selectMedicineIdRef.current) {
      setMedicines((prevMedicines) =>
        prevMedicines.map((medicine, idx) =>
          idx === select && String(medicine.id) === String(selectMedicineIdRef.current)
            ? {
                ...medicine,
                stock: medicineDetail?.payload?.stock_left,
                packing: medicineDetail?.payload?.packing,
              }
            : medicine,
        ),
      );
    }
  }, [medicineDetail, select]);

  // console.log(formState, "formState");
  // console.log(patient, 'patient')

  const handleQuantityChange = (index, field, value) => {
    if (value) {
      // console.log("hello");
      setMedicines((prevMedicines) =>
        prevMedicines.map((medicine, idx) =>
          idx === index
            ? {
                ...medicine,
                packing: null,
                unitMrp: null,
                mrp: null,
                discount: null,
                gst: null,
                amount: null,
              }
            : medicine,
        ),
      );
    }

    const newMedicines = medicines?.map((medicine, idx) =>
      idx === index ? { ...medicine, [field]: value } : medicine,
    );

    setMedicines(newMedicines);

    if (priceRequestControllers.current.has(index)) {
      priceRequestControllers.current.get(index).abort();
      priceRequestControllers.current.delete(index);
      pendingPriceCount.current -= 1;
      if (pendingPriceCount.current < 0) pendingPriceCount.current = 0;
    }

    // Clearing the quantity (or picking a batch before typing one) is not an
    // error. The backend answers 204 No Content for a blank quantity, which
    // comes back as null and would be reported below as "batch out of stock".
    // Drop the row's error state and skip the request instead.
    const quantityToPrice =
      field === "batchId" ? medicines[index]?.quantity : value;
    if (!quantityToPrice || Number(quantityToPrice) <= 0) {
      setMedicines((prev) =>
        prev.map((medicine, idx) =>
          idx === index ? { ...medicine, batchError: false } : medicine,
        ),
      );
      return;
    }

    if (medicines[index]?.id && !medicines[index]?.salt?.length) {
      const controller = new AbortController();
      priceRequestControllers.current.set(index, controller);
      pendingPriceCount.current += 1;
      setIsPriceFetching(true);

      getPriceByQuantity(
        medicines[index].id,
        field === "batchId" ? medicines[index].quantity : value,
        field === "batchId" ? value : medicines[index].batchId,
        id,
        controller.signal,
      )
        .then((res) => {
          // Error response (e.g. selected batch is out of stock) or malformed body
          if (res?.__httpError || !res?.payload?.batches) {
            console.log("get_price_by_quantity error body:", res);
            showToast(
              res?.payload?.message ||
                res?.status?.message ||
                res?.message ||
                res?.error ||
                res?.errors?.[0] ||
                "Selected batch is out of stock or unavailable.",
              "ERROR",
            );
            // Flag this row so the batch cell shows a red border
            setMedicines((prev) =>
              prev.map((medicine, idx) =>
                idx === index ? { ...medicine, batchError: true } : medicine,
              ),
            );
            return;
          }

          console.log(res.payload);
          const {
            selected_batch,
            discount,
            mrp,
            batches,
            unit_price,
            stock_left,
            grand_total,
            is_consumable,
          } = res.payload;

          const matchedBatch = batches?.find((b) => b.id === selected_batch?.id);

          // Update the medicine entry with the new price data
          const updatedMedicines = newMedicines?.map((medicine, idx) =>
            idx === index
              ? {
                  ...medicine,
                  batchId: selected_batch?.id,
                  batch: matchedBatch || selected_batch,
                  batchArray: batches,
                  stock: stock_left,
                  packing: matchedBatch?.packing || batches[0]?.packing,
                  unitMrp: medicine.returned ? -unit_price : unit_price,
                  mrp: medicine.returned ? -mrp : mrp,
                  discount: medicine.returned
                    ? `-${discount}%`
                    : `${discount}%`,
                  gst: matchedBatch?.gst ?? 0,
                  amount: medicine.returned ? -grand_total : grand_total,
                  is_consumable,
                  batchError: false,
                }
              : medicine,
          );
          setMedicines(updatedMedicines);
        })
        .catch((error) => {
          if (error?.name === "AbortError") return; // cancelled — ignore
          console.error("Error fetching price:", error);
          showToast(
            error?.status?.message || "Something went wrong fetching price.",
            "ERROR",
          );
          // Flag this row so the batch cell shows a red border
          setMedicines((prev) =>
            prev.map((medicine, idx) =>
              idx === index ? { ...medicine, batchError: true } : medicine,
            ),
          );
        })
        .finally(() => {
          priceRequestControllers.current.delete(index);
          pendingPriceCount.current -= 1;
          if (pendingPriceCount.current <= 0) {
            pendingPriceCount.current = 0;
            setIsPriceFetching(false);
          }
        });
    }
  };

  // console.log(medicines);
  const handleReturnChange = (index) => {
    const newMedicines = medicines?.map((medicine, idx) =>
      idx === index ? { ...medicine, returned: !medicine.returned } : medicine,
    );
    setMedicines(newMedicines);
    if (priceRequestControllers.current.has(index)) {
      priceRequestControllers.current.get(index).abort();
      priceRequestControllers.current.delete(index);
      pendingPriceCount.current -= 1;
      if (pendingPriceCount.current < 0) pendingPriceCount.current = 0;
    }

    const controller = new AbortController();
    priceRequestControllers.current.set(index, controller);
    pendingPriceCount.current += 1;
    setIsPriceFetching(true);

    if (medicines[index]?.id && !medicines[index]?.salt?.length) {
      getPriceByQuantityForReturn(
        medicines[index].id,
        medicines[index].quantity,
        id,
        controller.signal,
      )
        .then((res) => {
          console.log(res.payload);
          const {
            selected_batch,
            discount,
            mrp,
            batches,
            unit_price,
            grand_total,
            is_consumable,
          } = res.payload;

          const matchedBatch = batches?.find((b) => b.id === selected_batch?.id);

          // Update the medicine entry with the new price data
          const updatedMedicines = newMedicines?.map((medicine, idx) =>
            idx === index
              ? {
                  ...medicine,
                  batchId: selected_batch?.id,
                  batch: matchedBatch || selected_batch,
                  batchArray: batches,
                  stock: selected_batch?.stock_left,
                  packing: matchedBatch?.packing || batches[0]?.packing,
                  unitMrp: medicine.returned ? -unit_price : unit_price,
                  mrp: medicine.returned ? -mrp : mrp,
                  discount: medicine.returned
                    ? `-${discount}%`
                    : `${discount}%`,
                  gst: matchedBatch?.gst ?? 0,
                  amount: medicine.returned ? -grand_total : grand_total,
                  is_consumable,
                }
              : medicine,
          );

          setMedicines(updatedMedicines);
        })
        .catch((error) => {
          if (error?.name === "AbortError") return; // cancelled — ignore
          console.error("Error fetching price:", error);
        })
        .finally(() => {
          priceRequestControllers.current.delete(index);
          pendingPriceCount.current -= 1;
          if (pendingPriceCount.current <= 0) {
            pendingPriceCount.current = 0;
            setIsPriceFetching(false);
          }
        });
    }
  };

  const handleSelectMedicine = (index, salt) => {
    setMedicines((prevMedicines) =>
      prevMedicines.map((medicine, i) =>
        i === index
          ? {
              ...medicine,
              id: salt?.id,
              name: salt?.name,
              stock: salt?.stock_left,
              expiry_date: salt?.expiry_date,
              salt: [],
            }
          : medicine,
      ),
    );
    setSelect(index);
    selectMedicineIdRef.current = salt?.id;
    setSelectedMedicine({ name: salt?.name, id: salt?.id });
  };

  useEffect(() => {
    let totalAmount = 0;
    let discountTotal = 0;
    let validMedicinesCount = 0;
    let gstTotal = 0;
    const spDiscPct = parseFloat(specialDiscountPct) || 0;

    medicines?.forEach((medicine) => {
      if (medicine.name && medicine.quantity && medicine.quantity > 0 && medicine?.id) {
        validMedicinesCount++;
        const unitMrpAbs = parseFloat(medicine.unitMrp) || 0;
        const rawAmt = unitMrpAbs * (parseFloat(medicine.quantity) || 0);
        const amount = spDiscPct > 0 ? rawAmt * (1 - spDiscPct / 100) : (parseFloat(medicine.amount) || 0);
        const gstPct = parseFloat(medicine.gst) || 0;
        const gstAmount = amount * gstPct / (100 + gstPct);

        totalAmount += amount;
        gstTotal += gstAmount;

        if (rawAmt > 0) {
          const effectivePct = spDiscPct > 0 ? spDiscPct : (parseFloat(medicine.discount) || 0);
          discountTotal += rawAmt * (effectivePct / 100);
        }
      }
    });

    const taxableTotal = totalAmount - gstTotal;
    const netPayable = roundToNearestUnit(totalAmount, roundOff);
    setSelect(validMedicinesCount);
    setTotal(netPayable);
    setBillSummary({
      taxableTotal,
      totalGst: gstTotal,
      discount: discountTotal,
      netPayable,
    });

    setShowButton(validMedicinesCount > 0);
  }, [medicines, roundOff, specialDiscountPct]);

  specialDiscountPctRef.current = specialDiscountPct;

  useEffect(() => {
    const pct = parseFloat(specialDiscountPctRef.current);
    if (!specialDiscountPctRef.current || isNaN(pct) || pct <= 0) return;
    const raw = medicines.reduce((sum, m) => {
      if (m.name && m.quantity > 0 && m.id)
        return sum + (parseFloat(m.unitMrp) || 0) * (parseFloat(m.quantity) || 0);
      return sum;
    }, 0);
    setSpecialDiscountINR((raw * pct / 100).toFixed(2));
  }, [medicines]);

  // const handlePresence = async (index, value) => {
  //   const medicineNames = medicines
  //     ?.slice(0, medicines?.length > 1 ? medicines?.length - 1 : 0)
  //     .map((med) => med.name)
  //     .join(",");
  //   // encodeURIComponent(medicineNames)
  //   // console.log(medicineNames);
  //   try {
  //     const res = await getMedicineByName(
  //       encodeURIComponent(medicineNames),
  //       value[1]
  //     );

  //     //  console.log(res.payload?.presence);
  //     if (res?.payload?.presence) {
  //       const updatedMedicines = medicines.map((medicine, i) =>
  //         i === index
  //           ? { ...medicine, id: "", name: "", description: "", remark: "" }
  //           : medicine
  //       );

  //       // Update the state with the cleared fields
  //       setMedicines(updatedMedicines);

  //       console.log(updatedMedicines, "Updated medicines list");
  //       showToast("Medicine already present in the list", "ERROR");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   // console.log(value, " call api to check ");
  //   setFilteredMedicines([]);
  // };

  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "medicine invoice Print",
    onAfterPrint: () => console.log("Print job finished"),
  });

  const toNum = (v) => {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  };

  // 1) Default: keep row-0 amount synced with netPayable (only when NOT already split)
  useEffect(() => {
    setInvoicePaymentsAttributes((prev) => {
      const absT = Math.abs(Number(billSummary.netPayable || 0));

      // if already split (2 rows), keep remaining updated
      if (prev.length === 2) {
        const a1 = toNum(prev[0]?.amount);
        const remaining = Math.max(absT - a1, 0);
        return [
          { ...prev[0], amount: prev[0]?.amount ?? "" },
          { ...prev[1], amount: remaining.toFixed(2) },
        ];
      }

      // single row: always show abs netPayable
      const row0 = prev[0] || { payment_mode: "Cash", amount: "" };
      return [{ ...row0, amount: absT.toFixed(2) }];
    });
  }, [billSummary.netPayable]);

  // 2) When user edits first amount -> auto create/update/remove second row
  const handlePrimaryAmountChange = (value) => {
    setInvoicePaymentsAttributes((prev) => {
      const absT = Math.abs(Number(billSummary.netPayable || 0));
      const a1 = toNum(value);

      // If empty or zero, keep single row (collapse finalised on blur)
      if (value === "" || a1 === 0) {
        return [{ ...prev[0], amount: value }];
      }

      // If user enters >= abs total => keep single row only
      if (a1 >= absT) {
        return [{ ...prev[0], amount: value }];
      }

      // If user enters less than abs total => create/update second row for remaining
      const remaining = (absT - a1).toFixed(2);
      const row0 = { ...prev[0], amount: value };

      // if row2 exists update it else create it
      if (prev.length === 2) {
        return [row0, { ...prev[1], amount: remaining }];
      }

      return [
        row0,
        {
          amount: remaining,
          payment_mode: getAvailablePaymentModes(1)[0]?.value,
        }, // default second mode
      ];
    });
  };

  // 3) On blur: if primary is 0 or empty, collapse to single row
  const handlePrimaryAmountBlur = () => {
    setInvoicePaymentsAttributes((prev) => {
      const a1 = toNum(prev[0]?.amount);
      if (a1 === 0 || prev[0]?.amount === "") {
        const absT = Math.abs(Number(billSummary.netPayable || 0));
        return [{ ...prev[0], amount: absT.toFixed(2) }];
      }
      return prev;
    });
  };

  //   const paidTotal = invoicePaymentsAttributes.reduce(
  //   (sum, row) => sum + toNum(row?.amount),
  //   0,
  // );

  // const remainingTotal = (Number(total || 0) - paidTotal).toFixed(2);

  const validateForm = () => {
    let formValid = true;
    const newErrors = {};

    // ✅ PAYMENT VALIDATION (Smart split)
    const absTotal = Math.abs(Number(billSummary.netPayable || 0));
    const t = absTotal.toFixed(2);
    const rows = invoicePaymentsAttributes;

    if (!rows?.[0]?.payment_mode) {
      newErrors.split_payment = "Please select payment mode";
      formValid = false;
    } else {
      // row0 amount should exist
      const a1 = toNum(rows?.[0]?.amount);
      if (a1 <= 0 && absTotal > 0) {
        newErrors.split_payment = "Please enter valid amount";
        formValid = false;
      }

      if (rows.length === 2) {
        const a2 = toNum(rows?.[1]?.amount);

        if (!rows?.[1]?.payment_mode) {
          newErrors.split_payment =
            "Please select payment mode for 2nd payment";
          formValid = false;
        } else {
          const sum = (a1 + a2).toFixed(2);
          if (sum !== t) {
            newErrors.split_payment = `Payment total must equal invoice total (${t})`;
            formValid = false;
          }
        }
      } else {
        // single row must match total
        const sum = a1.toFixed(2);
        if (sum !== t) {
          newErrors.split_payment = `Amount must equal total (${t})`;
          formValid = false;
        }
      }
    }

    setErrors(newErrors);
    return formValid;
  };

  const updatePaymentRow = (index, key, value) => {
    setInvoicePaymentsAttributes((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [key]: value } : row)),
    );
  };

  //handle save & print invoice
  const saveAndPrint = async () => {
    if (isPriceFetching) {
      showToast("Price update in progress, please wait.", "WARNING");
      return;
    }
    if (!validateForm()) {
      setIsButtonDisable(false);
      return;
    }

    setIsButtonDisable(true);

    const invalidMedicines = medicines.filter(
      (medicine) =>
        medicine?.id && !medicine?.batchId && medicine?.is_consumable === false,
    );

    if (invalidMedicines.length > 0) {
      const names = invalidMedicines.map((m) => `[${m.name}]`).join(", ");
      showToast(
        `Batch not selected for ${names}. Please either select a batch or remove the medicine.`,
        "ERROR",
      );
      setIsButtonDisable(false);
      return;
    }

    const validMedicines = medicines?.filter(
      (medicine) =>
        medicine?.id && medicine?.quantity && medicine?.quantity > 0,
    );
    if (validMedicines.length === 0) {
      showToast(
        "At least one medicine is required to generate the invoice.",
        "ERROR",
      );
      setIsButtonDisable(false);
      return;
    }

    // ✅ DUPLICATE MEDICINE VALIDATION
    const medicineIds = validMedicines.map((m) => m.id);
    const duplicateMedicines = validMedicines.filter(
      (item, index) => medicineIds.indexOf(item.id) !== index,
    );

    if (duplicateMedicines.length > 0) {
      const duplicateNames = [
        ...new Set(duplicateMedicines.map((m) => `[${m.name}]`)),
      ].join(", ");
      showToast(
        `Duplicate medicine found for ${duplicateNames}. Please combine quantities into a single row or remove duplicates.`,
        "ERROR",
      );
      setIsButtonDisable(false);
      return;
    }

    // ✅ Stock Validation Check
    const insufficientStock = validMedicines?.filter((med) => {
      // Only check for items that are NOT returned
      if (!med?.returned) {
        const batchStock = med?.stock || 0;
        const requiredQty = med?.quantity || 0;
        return requiredQty > batchStock;
      }
      return false;
    });

    if (insufficientStock?.length > 0) {
      const errorMsg = insufficientStock
        .map(
          (med) =>
            `[${med?.name}] Batches , Available stocks: ${
              med?.stock || 0
            }, Required: ${med?.quantity})`,
        )
        .join(", ");
      showToast(`Insufficient stock for ${errorMsg}`, "ERROR");
      setIsButtonDisable(false);
      return;
    }

    const spDiscPct = parseFloat(specialDiscountPct) || 0;

    const formattedMedicines = validMedicines?.map((medicine) => {
      const rawAmt = (parseFloat(medicine?.unitMrp) || 0) * (parseFloat(medicine?.quantity) || 0);
      const effectivePct = spDiscPct > 0 ? spDiscPct : (parseFloat(medicine?.discount) || 0);
      const effectiveAmount = spDiscPct > 0 ? rawAmt * (1 - spDiscPct / 100) : (parseFloat(medicine?.amount) || 0);
      const discountValue = rawAmt * (effectivePct / 100);
      const discountPerUnit = (parseFloat(medicine?.unitMrp) || 0) * (effectivePct / 100);
      return {
        id: medicine?.id,
        name: medicine.name,
        batch: medicine?.batch?.id,
        packing: medicine?.packing,
        quantity: medicine?.quantity,
        cost_per_unit: medicine?.unitMrp,
        cost: rawAmt.toFixed(2),
        amount: effectiveAmount.toFixed(2),
        discount_per_unit: discountPerUnit.toFixed(2),
        discount: discountValue.toFixed(2),
        ...(spDiscPct > 0 ? { special_discount: spDiscPct } : {}),
        returned: medicine?.returned,
      };
    });

    const total = validMedicines.reduce((sum, medicine) => {
      return sum + (parseFloat(medicine?.unitMrp) || 0) * (parseFloat(medicine?.quantity) || 0);
    }, 0);

    const netTotal = validMedicines.reduce((sum, medicine) => {
      const rawAmt = (parseFloat(medicine?.unitMrp) || 0) * (parseFloat(medicine?.quantity) || 0);
      return sum + (spDiscPct > 0 ? rawAmt * (1 - spDiscPct / 100) : (parseFloat(medicine?.amount) || 0));
    }, 0);

    const totalGst = validMedicines.reduce((sum, medicine) => {
      const rawAmt = (parseFloat(medicine?.unitMrp) || 0) * (parseFloat(medicine?.quantity) || 0);
      const amt = spDiscPct > 0 ? rawAmt * (1 - spDiscPct / 100) : (parseFloat(medicine?.amount) || 0);
      const gstPct = parseFloat(medicine?.gst) || 0;
      return sum + amt * gstPct / (100 + gstPct);
    }, 0);

    const taxableTotal = netTotal - totalGst;
    const cgst = totalGst / 2;
    const sgst = totalGst / 2;
    const grandTotal = roundToNearestUnit(netTotal, roundOff);

    const discount = validMedicines.reduce((sum, medicine) => {
      const effectivePct = spDiscPct > 0 ? spDiscPct : (parseFloat(medicine.discount) || 0);
      const itemMrp = (parseFloat(medicine.unitMrp) || 0) * (parseFloat(medicine.quantity) || 0);
      return sum + itemMrp * (effectivePct / 100);
    }, 0);

    const invoice_payments_attributes = invoicePaymentsAttributes
      .slice(0, 2) // only allow max 2
      .map((p) => ({
        amount: Number(toNum(p.amount).toFixed(2)),
        payment_mode: p.payment_mode,
      }));

    const payload = {
      payment_mode: paymentMode,
      is_return: false,
      discount: discount.toFixed(2),
      ...(spDiscPct > 0 ? { special_discount: spDiscPct } : {}),
      total: total.toFixed(2),
      taxable_total: taxableTotal.toFixed(2),
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      grand_total: grandTotal.toFixed(2),
      config_round_off: roundOff,
      medicines: formattedMedicines,
      patient_id: patient?.patient?.id || null,
      prescription_id: formState?.prescription_id || id,
      invoice_payments_attributes,
    };
    const res = await pharmacyCreateBill(payload);
    setPrintInvoiceData(res);
    // console.log(res, "<-res");

    const statusMessage = res?.status?.status || "ERROR";
    const detailedMessage = res?.status?.message || "Something went wrong";
    showToast(statusMessage, detailedMessage);
    showToast(res?.status?.message || res?.status?.status, res?.status?.status);
    if (res?.status?.status === "SUCCESS") {
      refetch();
      setTimeout(() => {
        handlePrint();
        showToast(`Generating prescription PDF`, "SUCCESS");
        onClose();
      }, 0);
    }
    setIsButtonDisable(false);
  };

  const handleRemoveRow = (index) => {
    const newMedicines = medicines.filter((_, idx) => idx !== index);
    setMedicines(newMedicines);
  };
  const [editMedicine, setEditMedicine] = useState(false);
  const [selectedMedicineForEdit, setSelectedMedicineForEdit] = useState(null);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          height: "90vh",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "80vh",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
          >
            <Box></Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ReceiptLongIcon
                sx={{
                  color: "neutral.teal",
                  marginBottom: "4px",
                  marginRight: "8px",
                }}
              />
              <Typography
                variant="heading_Large"
                fontWeight={700}
                gutterBottom
                sx={headingStyle}
              >
                Bill
              </Typography>
            </Box>
            <IconButton onClick={onClose}>
              <CloseIcon size="small" sx={{ color: "red" }} />
            </IconButton>
          </Box>

          {isLoading ? (
            <Skeleton variant="rectangular" width="100%" height={30} />
          ) : (
            <Grid
              container
              sx={{
                justifyContent: "space-between",
                width: "100%",
                mt: "20px",
              }}
            >
              <Typography>Name: {patient?.patient?.name} </Typography>
              <Typography>Patient ID: {patient?.patient?.uid} </Typography>
              <Typography>Mobile: {patient?.patient?.mobile}</Typography>
              <Typography>Age : {patient?.patient?.age}</Typography>
              {patient?.patient?.gender && (
                <Typography> Gender: {patient?.patient?.gender}</Typography>
              )}
            </Grid>
          )}

          <Grid item xs={12}>
            <TableContainer
              sx={{
                mt: 2,
                width: "100%",
                overflowY: "scroll",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "-ms-overflow-style": "none",
                "scrollbar-width": "none",
              }}
            >
              <Table
                sx={{
                  width: "100%",
                  overflowY: "scroll",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  "-ms-overflow-style": "none",
                  "scrollbar-width": "none",
                }}
              >
                <TableHead stickyHeader>
                  <TableRow sx={{ ...drTableGreen, textAlign: "center" }}>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        borderTopLeftRadius: "20px",
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      ID
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        //  paddingX:"4px",
                        textAlign: "center",
                        width: "200px",
                      }}
                    >
                      Name
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        width: "150px",
                        paddingRight: "30px",
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Quantity
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Batch
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Return
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Total Stock
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Pack
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Unit MRP
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      MRP
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Discount
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      GST
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Amount
                    </TableCell>

                    {/* <TableCell
                                                          variant="body1_text_bold"
                                                          sx={{
                                                              color: 'neutral.white',
                                                              p: "8px",
              
                                                              textAlign: "center",
                                                          }}
                                                      >
                                                          Edit
                                                      </TableCell> */}

                    <TableCell
                      sx={{
                        p: "4px",
                        textAlign: "center",
                        borderTopRightRadius: "20px",
                      }}
                    >
                      <IconButton
                        onClick={handleAddRow}
                        sx={{
                          ...orangeButton,
                          marginLeft: "7px",
                          marginY: "2px",
                        }}
                      >
                        <AddIcon
                          sx={{
                            color: "neutral.white",
                            width: "30px",
                            height: "32px",
                            padding: "0px",
                          }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                </TableHead>

                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={14}>
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={300}
                        sx={{ backgroundColor: "lightgray", marginTop: "10px" }}
                      />
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableBody>
                    {medicines?.length > 0 &&
                      medicines?.map((medicine, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            ...tableRowLab,
                            // borderBottom: "7px solid white",
                            // borderTop: index === 0 ? "4px solid white" : " ",
                            //  pointerEvents:
                            //   medicine?.id === null ? "none" : "auto",

                            // "&:hover": {
                            //   transform: "scale(1.001)",
                            //   // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                            //   borderRadius: "20px !important",
                            // },
                            // opacity: medicine?.id === null ? 0.6 : 1,
                          }}
                        >
                          <TableCell
                            sx={{
                              ...tableCellLab,
                              // borderBottomLeftRadius:
                              //   index === medicines?.length - 1 ? 20 : 0,
                            }}
                          >
                            <Typography
                              variant="body_Grey1"
                              color={"text.grey"}
                            >
                              {index + 1}
                            </Typography>
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            <Autocomplete
                              options={filteredMedicines}
                              freeSolo
                              clearOnEscape={false}
                              // clearIcon={null}
                              open={openMedicineList === index}
                              onOpen={() => setOpenMedicines(index)}
                              onClose={() => setOpenMedicines(false)}
                              id={`name-${index}`}
                              inputValue={
                                medicine?.name !== null ? medicine?.name : ""
                              }
                              onInputChange={(e, value) => {
                                handleChange(index, "name", value, e);
                              }}
                              onChange={(e, value) => {
                                // console.log(value);
                                if (!value) {
                                  // console.log("hello");
                                  setMedicines((prevMedicines) =>
                                    prevMedicines.map((medicine, idx) =>
                                      idx === index
                                        ? {
                                            id: "",
                                            name: "",
                                            quantity: "",
                                            batchId: null,
                                            batch: "",
                                            batchArray: [],
                                            returned: false,
                                            stock: "",
                                            salt: [],
                                            packing: "",
                                            unitMrp: null,
                                            mrp: null,
                                            discount: null,
                                            gst: null,
                                            amount: null,
                                          }
                                        : medicine,
                                    ),
                                  );
                                  setSelectedMedicineForEdit(null);
                                  setSelectedMedicine(null);
                                } else if (value && medicine?.id) {
                                  handleChange(index, "id", value[0]);
                                  handlePresence(index, value);
                                  setSelect(index);
                                  selectMedicineIdRef.current = value[0];
                                  setSelectedMedicine({
                                    name: value[1],
                                    id: value[0],
                                  });
                                  setMedicines((prevMedicines) =>
                                    prevMedicines?.map((medicine, idx) =>
                                      idx === index
                                        ? {
                                            ...medicine,
                                            quantity: "",
                                            batchId: null,
                                            batch: "",
                                            batchArray: [],
                                            returned: false,
                                            stock: "",
                                            packing: "",
                                            unitMrp: null,
                                            mrp: null,
                                            discount: null,
                                            gst: null,
                                            amount: null,
                                          }
                                        : medicine,
                                    ),
                                  );
                                  setTimeout(() => {
                                    document
                                      .getElementById(`quantity-${index}`)
                                      .focus();
                                  }, 0);
                                } else {
                                  // console.log(value, 'value inside autocomplete ')
                                  handleChange(index, "id", value[0]);
                                  handlePresence(index, value);
                                  setSelect(index);
                                  selectMedicineIdRef.current = value[0];
                                  setSelectedMedicine({
                                    name: value[1],
                                    id: value[0],
                                  });

                                  setTimeout(() => {
                                    document
                                      .getElementById(`quantity-${index}`)
                                      .focus();
                                  }, 0);
                                }
                              }}
                              sx={{
                                ...textfieldTextBlueBorderPharmacy,
                                border:
                                  medicine?.id === null
                                    ? "1px solid red"
                                    : "none",
                                borderRadius:
                                  medicine?.id === null ? "11px" : "0",
                                ...(medicine?.id === null && {
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      border: "none",
                                    },
                                }),
                                // Added proper border-radius styling
                                // opacity: medicine?.id === null ? 0.9 : 1,
                              }}
                              PopperComponent={(props) => (
                                <Grid item lg={8}>
                                  <Popper
                                    {...props}
                                    placement="bottom-start"
                                    style={menuItemStyle}
                                    modifiers={[
                                      {
                                        name: "preventOverflow",
                                        options: {
                                          boundary: "block",
                                        },
                                      },
                                    ]}
                                  >
                                    <div
                                      style={{
                                        maxHeight: 300,
                                        overflowY: "auto",
                                        scrollbarWidth: "none",
                                        maxWidth: "320px",
                                        minWidth: "310px",
                                      }}
                                    >
                                      {props.children}
                                    </div>
                                  </Popper>
                                </Grid>
                              )}
                              getOptionLabel={(option) => option[1] || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  onChange={handleSearch}
                                  value={searchTerm}
                                  placeholder="Medicine"
                                  onKeyDown={(e) =>
                                    handleKeyDown(e, index, "name")
                                  }
                                />
                              )}
                              // renderOption={(props, option, { index }) => (
                              //   <MenuItem
                              //     sx={{
                              //       ...menuItemStyle,
                              //       "&:hover": {
                              //         backgroundColor: "#f58633 !important",
                              //         color: "white !important",
                              //       },
                              //       ...(index === 0 && {
                              //         backgroundColor: "#f58633 !important",
                              //         color: "white !important",
                              //       }),
                              //     }}
                              //     {...props}
                              //     key={option[0]}
                              //   >
                              //     {option[1]}
                              //   </MenuItem>
                              // )}
                              renderOption={(props, option, { index }) => (
                                <MenuItem
                                  sx={{
                                    ...menuItemStyle,
                                    "&:hover": {
                                      backgroundColor: "#9fd8d8ff !important",
                                      // borderRadius:"20%",
                                      borderRadius: "16px",
                                      color: "black !important",
                                    },
                                    ...(index === highlightedIndexMedicine && {
                                      backgroundColor: "#9fd8d8ff !important",
                                      color: "black !important",
                                      borderRadius: "16px",
                                    }),
                                  }}
                                  {...props}
                                  key={option[0]}
                                >
                                  {option[1]}
                                </MenuItem>
                              )}
                            />

                            {medicine?.salt?.length > 0 && (
                              <TableContainer
                                sx={{
                                  ...borderInset,
                                  marginTop: "5px",
                                  maxHeight: "200px",
                                  width: "380px",
                                  overflowY: "auto",
                                  borderRadius: "10px",
                                  "&::-webkit-scrollbar": {
                                    display: "none",
                                  },
                                  /* Hide scrollbar for Firefox */
                                  scrollbarWidth: "none",
                                  /* Hide scrollbar for IE, Edge */
                                  msOverflowStyle: "none",
                                  border: "1px solid rgba(0, 0, 0, 0.2)",
                                  // padding:'10px',
                                }}
                              >
                                <Table
                                  component={Paper}
                                  sx={{
                                    width: "380px",
                                  }}
                                >
                                  <TableHead>
                                    <TableRow
                                      sx={{ backgroundColor: "#257184ff" }}
                                    >
                                      <TableCell
                                        sx={{
                                          padding: "2px",
                                          borderTopLeftRadius: "10px",
                                          borderBottomLeftRadius: "10px",
                                          width: "45%",
                                        }}
                                      >
                                        <Typography
                                          color={"white"}
                                          textAlign={"center"}
                                        >
                                          Name
                                        </Typography>
                                      </TableCell>

                                      <TableCell
                                        sx={{ padding: "2px", width: "25%" }}
                                      >
                                        <Typography
                                          color={"white"}
                                          textAlign={"center"}
                                        >
                                          Stock
                                        </Typography>
                                      </TableCell>

                                      <TableCell
                                        sx={{
                                          padding: "2px",
                                          borderTopRightRadius: "10px",
                                          borderBottomRIghtRadius: "10px",
                                          width: "30%",
                                        }}
                                      >
                                        <Typography
                                          color={"white"}
                                          textAlign={"center"}
                                        >
                                          Exp
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {medicine?.salt?.map((item, idx) => (
                                      <TableRow key={idx}>
                                        <TableCell
                                          sx={{
                                            padding: "5px",
                                            width: "50%",
                                            alignItems: "center",
                                          }}
                                        >
                                          {/* <Box sx={{display:'flex' ,  justifyContent:'center' , alignItems:'center' , margin:'0px' , padding:'0px',width:'100%' }}> */}
                                          <Brightness1OutlinedIcon
                                            variant="subTitle1"
                                            id={`selectSalt-${index}-${idx}`}
                                            // color={"neutral.brown"}
                                            sx={{
                                              // padding:'5px',
                                              marginBottom: "-8px",
                                              marginRight: "2px",
                                              width: "18px",
                                              outline: "none",
                                              "&:focus": {
                                                fontWeight: "1400",
                                                color: "neutral.teal",
                                              },
                                              color: "gray",
                                            }}
                                            tabIndex={idx}
                                            onClick={() =>
                                              handleSelectMedicine(index, item)
                                            }
                                            onKeyDown={(e) => {
                                              if (e.key === "Tab") {
                                                // Call handleSelectMedicine when Tab is pressed
                                                handleSelectMedicine(
                                                  index,
                                                  item,
                                                );
                                              }
                                            }}
                                          />

                                          <Typography variant="subTitle1">
                                            {item?.name}
                                          </Typography>
                                          {/* </Box> */}
                                        </TableCell>

                                        <TableCell
                                          sx={{
                                            width: "20%",
                                            padding: "5px",
                                            textAlign: "center",
                                          }}
                                        >
                                          <Typography variant="subTitle1">
                                            {item?.stock_left}
                                          </Typography>
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            width: "30%",
                                            padding: "5px",
                                            textAlign: "center",
                                          }}
                                        >
                                          <Typography variant="subTitle1">
                                            {item?.expiry_date}
                                          </Typography>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            )}
                          </TableCell>

                          <TableCell sx={{ ...tableCellLab }}>
                            <TextField
                              id={`quantity-${index}`}
                              fullWidth
                              placeholder="Quantity"
                              type="number"
                              variant="outlined"
                              value={medicine?.quantity}
                              sx={textfieldTextBlueBorderPharmacy}
                              onKeyDown={(e) =>
                                handleKeyDown(e, index, "quantity")
                              }
                              onChange={(e) => {
                                if (e.target.value < 0) {
                                  return;
                                }
                                handleChange(index, "quantity", e.target.value);
                                handleQuantityChange(
                                  index,
                                  "quantity",
                                  e.target.value,
                                );
                              }}
                              inputProps={{
                                min: 0,
                              }}
                            />
                          </TableCell>

                          <TableCell
                            sx={{
                              ...tableCellLab,
                              width: "100px",
                              pointerEvents:
                                medicine?.id === null ? "none" : "auto",
                              opacity: medicine?.id === null ? 0.6 : 1,
                            }}
                          >
                            <FormControl fullWidth variant="outlined">
                              <Select
                                sx={{
                                  ...textfieldTextBlueBorderPharmacy,
                                  backgroundColor: "white",
                                  borderRadius: "10px",
                                  "& .MuiSelect-select": {
                                    padding: "9px", // Custom padding for select dropdown
                                  },
                                  minWidth: "130px",
                                  ...(medicine?.batchError && {
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "#ed5564 !important",
                                      borderWidth: "1.5px",
                                    },
                                    borderColor: "#ed5564 !important",
                                  }),
                                }}
                                placeholder="batch"
                                fullWidth
                                value={medicines[index]?.batchId || ""}
                                onChange={(e) => {
                                  handleChange(
                                    index,
                                    "batchId",
                                    e.target.value,
                                  );
                                  handleQuantityChange(
                                    index,
                                    "batchId",
                                    e.target.value,
                                  );
                                }}
                                renderValue={(selected) => {
                                  // Find the selected batch object by ID
                                  const selectedBatch = medicines[
                                    index
                                  ]?.batchArray?.find(
                                    (batch) => batch.id === selected,
                                  );
                                  return (
                                    selectedBatch?.batch_no || "Select Batch"
                                  );
                                }}
                              >
                                {medicines[index]?.batchArray?.map((batch) => (
                                  <MenuItem key={batch.id} value={batch.id}>
                                    <Box display="flex" flexDirection="column">
                                      <Typography
                                        fontSize="14px"
                                        fontWeight={400}
                                      >
                                        {batch?.batch_no}
                                      </Typography>

                                      <Typography
                                        fontSize="12px"
                                        color="text.secondary"
                                      >
                                        {`${batch?.stock_left}  |  `}
                                        {expiryMedicineFormate(
                                          batch?.expiry_date,
                                        )}
                                      </Typography>
                                    </Box>
                                  </MenuItem>
                                ))}
                              </Select>
                              {/* Render the batch stock and expiry date */}

                              {!medicine?.batchId &&
                              medicine?.is_consumable === false ? (
                                <FormHelperText>
                                  Please select a batch.
                                </FormHelperText>
                              ) : (
                                ""
                              )}

                              <Box
                                justifyContent={"space-between"}
                                display={"flex"}
                                paddingX={"2px"}
                              >
                                <Typography
                                  fontSize={"12px"}
                                  color={` ${
                                    medicine?.quantity >
                                      medicines[index]?.batch?.stock_left ||
                                    isExpiredDate(
                                      medicines[index]?.batch?.expiry_date,
                                    )
                                      ? "#ed5564"
                                      : medicine?.batchError
                                        ? "#ed5564"
                                        : "text.grey"
                                  } `}
                                >
                                  {medicine?.batchError
                                    ? "0"
                                    : medicines[index]?.batch?.stock_left}
                                </Typography>
                                <Typography fontSize={"12px"}>
                                  {expiryMedicineFormate(
                                    medicines[index]?.batch?.expiry_date,
                                  )}
                                </Typography>
                              </Box>
                            </FormControl>
                          </TableCell>

                          <TableCell sx={{ ...tableCellLab }}>
                            <Checkbox
                              id={`return-${index}`}
                              checked={medicine?.returned}
                              onKeyDown={(e) =>
                                handleKeyDown(e, index, "return")
                              }
                              onChange={() => handleReturnChange(index)}
                              sx={{ height: "10px", width: "10px" }}
                            />
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            <Typography
                              variant="body_Grey1"
                              color={` ${
                                medicine?.quantity > medicine.stock
                                  ? "#ed5564"
                                  : "text.grey"
                              } `}
                            >
                              {medicine?.stock}
                            </Typography>
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            <Typography
                              variant="body_Grey1"
                              color={"text.grey"}
                            >
                              {medicine?.packing}
                            </Typography>
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            {medicine?.returned ? (
                              <Typography
                                variant="body_Grey1"
                                color={"#ed5564"}
                              >
                                {" "}
                                {isNaN(+medicine?.unitMrp)
                                  ? ""
                                  : medicine?.unitMrp}{" "}
                              </Typography>
                            ) : (
                              <Typography
                                variant="body_Grey1"
                                color={"text.grey"}
                              >
                                {isNaN(+medicine?.unitMrp)
                                  ? ""
                                  : medicine?.unitMrp}{" "}
                              </Typography>
                            )}
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            {medicine.returned ? (
                              <Typography
                                variant="body_Grey1"
                                color={"#ed5564"}
                              >
                                {" "}
                                {medicine?.mrp}{" "}
                              </Typography>
                            ) : (
                              <Typography
                                variant="body_Grey1"
                                color={"text.grey"}
                              >
                                {medicine?.mrp}
                              </Typography>
                            )}
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            {medicine.returned ? (
                              <Typography
                                variant="body_Grey1"
                                color={"#ed5564"}
                              >
                                {" "}
                                {specialDiscountPct ? `${specialDiscountPct}%` : medicine?.discount}{" "}
                              </Typography>
                            ) : (
                              <Typography
                                variant="body_Grey1"
                                color={"text.grey"}
                              >
                                {specialDiscountPct ? `${specialDiscountPct}%` : medicine?.discount}
                              </Typography>
                            )}
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            <Typography
                              variant="body_Grey1"
                              color={"text.grey"}
                            >
                              {medicine.gst}
                            </Typography>
                          </TableCell>

                          <TableCell sx={tableCellLab}>
                            {medicine.returned ? (
                              <Typography
                                variant="body_Grey1"
                                color={"#ed5564"}
                              >
                                {" "}
                                {specialDiscountPct
                                  ? ((parseFloat(medicine?.unitMrp) || 0) * (parseFloat(medicine?.quantity) || 0) * (1 - parseFloat(specialDiscountPct) / 100)).toFixed(2)
                                  : medicine?.amount}{" "}
                              </Typography>
                            ) : (
                              <Typography
                                variant="body_Grey1"
                                color={"text.grey"}
                              >
                                {specialDiscountPct
                                  ? ((parseFloat(medicine?.unitMrp) || 0) * (parseFloat(medicine?.quantity) || 0) * (1 - parseFloat(specialDiscountPct) / 100)).toFixed(2)
                                  : medicine?.amount}
                              </Typography>
                            )}
                          </TableCell>

                          <TableCell
                            sx={{
                              ...tableCellLab,
                              // borderBottomRightRadius:
                              //   index === medicines?.length - 1 ? 20 : 0,
                            }}
                          >
                            <IconButton
                              sx={{ marginLeft: "8px", marginBottom: "7px" }}
                              onClick={() => handleRemoveRow(index)}
                            >
                              <CloseIcon
                                sx={{ ...xBtn, width: "26px", height: "26px" }}
                              />
                            </IconButton>

                            {medicine?.id && (
                              <IconButton
                                // sx={{ marginLeft: '8px', marginBottom: "7px", }}
                                onClick={() => {
                                  setSelectedMedicineForEdit(medicine?.id);
                                  setEditMedicine(true);
                                }}
                              >
                                <Edit
                                  sx={{
                                    ...xBtn,
                                    width: "23px",
                                    height: "23px",
                                    borderRadius: "50%",
                                    p: 0.4,
                                    color: "neutral.white",
                                    // border: '2px solid #007A99',
                                    backgroundColor: "neutral.teal",
                                    "&:hover": {
                                      backgroundColor: "neutral.teal",
                                    },
                                    marginBottom: "7px",
                                  }}
                                />
                              </IconButton>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Grid>
        </Box>

        {/* Payment + Save*/}
        <Paper
          elevation={6}
          sx={{
            position: "sticky",
            bottom: 0,
            zIndex: 20,
            mt: 1,
            minHeight: "max-content",
            borderRadius: "16px",
            overflow: "hidden",
            border: "1px solid rgba(0,0,0,0.08)",
            backdropFilter: "blur(6px)",
          }}
        >
          {/* Top row */}
          <Box
            sx={{
              px: 2,
              py: 1.5,
              background:
                "linear-gradient(180deg, rgba(0,103,255,0.06), rgba(0,0,0,0))",
            }}
          >
            <Stack
              direction={{ xs: "column"}}
              spacing={2}
              alignItems={{ xs: "start",}}
              justifyContent="space-between"
            >
              <Stack
                direction="row"
                // spacing={2}
                gap={2}
                alignItems="center"
                flexWrap="wrap"
                sx={{ flex: 1 }}
              >
                {/* Row 1 */}
                <FormControl sx={{ minWidth: 200 }} variant="outlined">
                  <InputLabel shrink id="payment-mode-label-0">
                    Payment Mode
                  </InputLabel>
                  <Select
                    labelId="payment-mode-label-0"
                    label="Payment Mode"
                    value={
                      invoicePaymentsAttributes?.[0]?.payment_mode || "Cash"
                    }
                    onChange={(e) =>
                      updatePaymentRow(0, "payment_mode", e.target.value)
                    }
                    sx={{
                      ...selectField,
                      height: 44,
                      backgroundColor: "white",
                    }}
                  >
                    {getAvailablePaymentModes(0).map((m) => (
                      <MenuItem
                        key={m.value}
                        value={m.value}
                        sx={menuItemStyle}
                      >
                        {m.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="Net Payable"
                  type="text"
                  inputProps={{ inputMode: "decimal" }}
                  value={invoicePaymentsAttributes?.[0]?.amount ?? ""}
                  onChange={(e) => handlePrimaryAmountChange(e.target.value)}
                  onBlur={handlePrimaryAmountBlur}
                  shrink={true}
                  sx={{
                    ...textfieldTextPrep,
                    width: 220,
                    "& .MuiInputBase-root": {
                      height: 44,
                      backgroundColor: "white",
                    },
                  }}
                />

                {/* Row 2 appears automatically */}
                {invoicePaymentsAttributes.length === 2 && (
                  <>
                    <FormControl sx={{ minWidth: 200 }} variant="outlined">
                      <InputLabel shrink id="payment-mode-label-1">
                        Payment Mode 2
                      </InputLabel>
                      <Select
                        labelId="payment-mode-label-1"
                        label="Mode 2"
                        value={
                          invoicePaymentsAttributes?.[1]?.payment_mode || "Cash"
                        }
                        onChange={(e) =>
                          updatePaymentRow(1, "payment_mode", e.target.value)
                        }
                        sx={{
                          ...selectField,
                          height: 44,
                          backgroundColor: "white",
                        }}
                      >
                        {getAvailablePaymentModes(1).map((m) => (
                          <MenuItem
                            key={m.value}
                            value={m.value}
                            sx={menuItemStyle}
                          >
                            {m.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField
                      label="Remaining"
                      value={invoicePaymentsAttributes?.[1]?.amount ?? ""}
                      inputProps={{ readOnly: true }}
                      sx={{
                        ...textfieldTextPrep,
                        width: 220,
                        "& .MuiInputBase-root": {
                          height: 44,
                          backgroundColor: "#f7f7f7",
                        },
                      }}
                    />
                  </>
                )}
                   {/* Special Discount fields */}
                 <TextField
                  label="Special Discount %"
                  type="number"
                  value={specialDiscountPct}
                  onChange={(e) => handleSpecialDiscountPct(e.target.value)}
                  inputProps={{ min: 0, max: 100, step: 0.01 }}
                  sx={{
                    ...textfieldTextPrep,
                    width: 180,
                    "& .MuiInputBase-root": { height: 44, backgroundColor: "white" },
                  }}
                />
                <TextField
                  label="Special Discount ₹"
                  type="number"
                  value={specialDiscountINR}
                  onChange={(e) => handleSpecialDiscountINR(e.target.value)}
                  inputProps={{ min: 0, step: 0.01 }}
                  sx={{
                    ...textfieldTextPrep,
                    width: 180,
                    "& .MuiInputBase-root": { height: 44, backgroundColor: "white" },
                  }}
                />
              </Stack>

           
             

              {/* Summary */}
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent={{ xs: "flex-start", md: "flex-end" }}
                flexWrap="wrap"
              >
                <Chip
                  label={
                    <Typography fontWeight={800}>
                      Taxable Amt: {Number(billSummary.taxableTotal || 0).toFixed(2)}
                    </Typography>
                  }
                />
                <Chip
                  label={
                    <Typography fontWeight={800}>
                      GST: {Number(billSummary.totalGst || 0).toFixed(2)}
                    </Typography>
                  }
                />
                <Chip
                  label={
                    <Typography fontWeight={800}>
                      Discount: {Number(billSummary.discount || 0).toFixed(2)}
                    </Typography>
                  }
                />
                {roundOff !== null && roundOff !== undefined && (
                  <Chip
                    label={
                      <Typography fontWeight={800}>
                        Round Off: {roundOff}
                      </Typography>
                    }
                  />
                )}
                <Chip
                  sx={{ backgroundColor: "#e8f5e9" }}
                  label={
                    <Typography fontWeight={800} color="green">
                      Net Payable: {Number(billSummary.netPayable || 0).toFixed(2)}
                    </Typography>
                  }
                />
              </Stack>
            </Stack>

            {errors.split_payment && (
              <Typography color="error" fontSize="12px" mt={1}>
                {errors.split_payment}
              </Typography>
            )}
          </Box>

          {/* Split payment rows */}
          {/* <Collapse in={paymentSplitEnabled} timeout={200} s>
                <Divider />
                <Box sx={{ px: 2, py: 1.5 }}>
                  <Stack spacing={1.25}>
                    {invoicePaymentsAttributes.map((row, index) => (
                      <Stack
                        key={index}
                        direction={{ xs: "column", sm: "row" }}
                        spacing={1.25}
                        alignItems={{ xs: "stretch", sm: "center" }}
                      >
                        <FormControl sx={{ minWidth: 200 }} variant="outlined">
                          <InputLabel shrink id={`split-mode-${index}`}>
                            Mode
                          </InputLabel>
    
                          <Select
                            labelId={`split-mode-${index}`}
                            label="Mode"
                            value={row.payment_mode}
                            onChange={(e) =>
                              updatePaymentRow(
                                index,
                                "payment_mode",
                                e.target.value,
                              )
                            }
                            sx={{
                              ...selectField,
                              height: 44,
                              backgroundColor: "white",
                            }}
                          >
                            {paymentModes.map((m) => (
                              <MenuItem
                                key={m.value}
                                value={m.value}
                                sx={menuItemStyle}
                              >
                                {m.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
    
                        <TextField
                          label="Amount"
                          type="number"
                          value={row.amount}
                          onChange={(e) => {
                            const v = e.target.value;
                            if (+v < 0) return;
                            updatePaymentRow(index, "amount", v);
                          }}
                          sx={{
                            ...textfieldTextPrep,
                            width: { xs: "100%", sm: 260 },
                            "& .MuiInputBase-root": {
                              height: 44,
                              backgroundColor: "white",
                            },
                          }}
                        />
                      </Stack>
                    ))}
    
                    {errors.split_payment && (
                      <Typography color="error" fontSize="12px">
                        {errors.split_payment}
                      </Typography>
                    )}
                  </Stack>
                </Box>
              </Collapse> */}

          {/* Bottom action row */}
          <Divider />
          <Box
            sx={{
              px: 2,
              py: 1.5,
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
              backgroundColor: "rgba(0,0,0,0.015)",
            }}
          >
            <Button
              disabled={
                isLoading ||
                isButtonDisable ||
                isPriceFetching ||
                (allowBatchStockZero &&
                  medicines.some((m) => m?.batchError))
              }
              onClick={saveAndPrint}
              variant="contained"
              id="submit"
              sx={{
                ...primaryBtnTeal,
                height: 44,
                width: { xs: "100%", sm: 220 },
                borderRadius: "12px",
                // fontWeight: 800,
              }}
            >
              Save & Print
            </Button>
          </Box>
        </Paper>
      </Box>

      <div style={{ display: "none" }}>
        <PharmacyInvoice props={printInvoiceData} ref={printRef} />
      </div>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "90%" }}
        open={editMedicine}
        onClose={() => setEditMedicine(false)}
      >
        <EditMedicineBatchShort
          onClose={() => setEditMedicine(false)}
          id={selectedMedicineForEdit}
        />
      </CustomModal>
    </>
  );
};
export default PrePatientBillPharmacy;
